module.exports = __webpack_public_path__ + "img/repair_economy.mars.6ec2965.png";